import { autobind } from 'frontools/decorators/Autobind';
import ComponentAbstract from '../core/components/ComponentAbstract';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';

export class Explosion extends ComponentAbstract {

    private _sprite                 : PIXI.extras.AnimatedSprite;
    private _scale                  : number                = .5;
    public static DESTROYED         : string                = 'destroyed';


    constructor(x: number, y: number, color: number) {
        super();
        
        this._sprite = Assets.getSpriteFromJson('explosion') as PIXI.extras.AnimatedSprite;
        this._sprite.pivot.x = this._sprite.width / 2;
        this._sprite.pivot.y = this._sprite.height / 2;
        this._sprite.x = x;
        this._sprite.y = y;
        this._sprite.animationSpeed = .5;
        this._sprite.scale = new PIXI.Point(this._scale, this._scale);
        this._sprite.tint = color;
        this._sprite.loop = false;
        this._sprite.play();
        this._sprite.onComplete = this.destroy.bind(this);
    
    };


    public get sprite(): PIXI.extras.AnimatedSprite {
        return this._sprite;
    }


    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        super.destroy();
        this.dispatch(Explosion.DESTROYED);

        this._sprite.destroy();
    };


}


export interface ILevelConfig {
    index: number;
    character: string;
    particleColor: number;
    faceOffsetX: number;
    faceOffsetY: number;
    posOffsetY?: number;
    gridSizeH: number;
    gridSizeV: number;
}